import { render, staticRenderFns } from "./deployment.vue?vue&type=template&id=36c34d6c&"
import script from "./deployment.vue?vue&type=script&lang=js&"
export * from "./deployment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports